<div class="row">
  <div class="col">
    <label class="ms-3" for="openingTime">Opening time</label>
    <ngb-timepicker
      id="openingTime"
      name="openingTime"
      [minuteStep]="15"
      [(ngModel)]="storeWorkingTime.openingTime"
      pattern="\d{2}:(00|15|30|45)(:00)?"
      required
      #openingTime="ngModel">
    </ngb-timepicker>
    @if (openingTime.errors && openingTime.touched) {
      <div class="form-error-message">
        @if (openingTime.errors.required) {
          <p>Opening time is required</p>
        }
        @if (openingTime.errors.pattern) {
          <p>Opening time must be in 15 minutes increments</p>
        }
      </div>
    }
  </div>
  <div class="col">
    <label class="ms-3" for="closingTime">Closing time</label>
    <ngb-timepicker
      id="closingTime"
      name="closingTime"
      [minuteStep]="15"
      [(ngModel)]="storeWorkingTime.closingTime"
      pattern="\d{2}:(00|15|30|45)(:00)?"
      required
      #closingTime="ngModel">
    </ngb-timepicker>
    @if (closingTime.errors && closingTime.touched) {
      <div class="form-error-message">
        @if (closingTime.errors.required) {
          <p>Closing time is required</p>
        }
        @if (closingTime.errors.pattern) {
          <p>Closing time must be in 15 minutes increments</p>
        }
      </div>
    }
  </div>
</div>